import React, {useState} from "react";
import {useTheme, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomChipComponent from "../../../core/components/common/custom-chip.component";
import UpdateIcon from "@mui/icons-material/Update";
import {useNavigate, useLocation} from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UpdateStatusDialog from "./update-status.dialog";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { useGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";

const CustomMenuPopperComponent = (props) => {
    const {data, setSelectedVehicle, setOpen, theme, customIconStyles, organizationId, profile_type} = props;

    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const {hasPermission} = useGuard()
        
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    }
        
    const handleClose = () => {
        setAnchorEl(null);
    }
    
    const handleUpdateStatus = () => {
        setSelectedVehicle(data);
        setOpen(true);
    }

    const handleViewDetails = (e, data) => {
        if (organizationId) {
            if (profile_type === "Business") {
                navigate(`/vehicles/view?org_uid=${organizationId}&id=${data.vehicle_uid}`);
                
            } else {
                navigate(`/organization/view/vehicles/view?org_uid=${organizationId}&id=${data.vehicle_uid}`);
            } 

        } else {
            navigate(`/vehicles/view?id=${data.vehicle_uid}`);
        }
    }

    const handleEditVehicle = (e, data) => {
        if (organizationId) {
            if (profile_type === "Business") {
                navigate(`/vehicles/edit?org_uid=${organizationId}&id=${data.vehicle_uid}`);
            } else {
                navigate(`/organization/view/vehicles/edit?org_uid=${organizationId}&id=${data.vehicle_uid}`);
            }   
        
        } else {
            navigate(`/vehicles/edit?id=${data.vehicle_uid}`);
        }
    }

    const menuItems = [
        {
            icon: <VisibilityIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "View Details",
            onClick: (e) => handleViewDetails(e, data),
            requiredPermission: permissions.vehicle.VIEW_VEHICLE,
        },
        {
            icon: <BorderColorIcon fontSize="small" sx={{color: theme.palette.primary.main}} />,
            label: "Edit Vehicle",
            onClick: (e) => handleEditVehicle(e, data),
            requiredPermission: permissions.vehicle.UPDATE_VEHICLE,
        },
        {
            icon: <UpdateIcon fontSize="small" sx={{color: theme.palette.primary.main, fontSize: 23}} />,
            label: "Update Status",
            onClick: (e) => handleUpdateStatus(e, data),
            requiredPermission: permissions.vehicle.CHANGE_STATUS_VEHICLE,
        }
    ].filter((item) => hasPermission(item.requiredPermission))


    return (
        <>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
  
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{style: {maxHeight: 300}}}
            >
                {menuItems?.map((item, index) => (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            handleClose();
                            item.onClick();
                        }}
                        sx={{}}
                    >
                        <ListItemIcon sx={customIconStyles}>
                            {item.icon}
                        </ListItemIcon>
            
                        <ListItemText sx={{ml: "-3px"}} primary={item.label} />
                    </MenuItem>
                ))}
            </Menu>
        </>
    )
}

const ListVehicleComponent = (props) => {
    const {headers, data, isMobile, breakpoints} = props;

    const theme = useTheme();
    const location = useLocation();

    const [open, setOpen] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState();

    const organizationId = new URLSearchParams(location.search).get("org_uid");
    const profile_type = localStorage.getItem("profile_type");


    return (
        <Paper elevation={0} sx={{width: "100%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <TableContainer>
                <Table>
                    <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                        <TableRow>
                            {headers.map((header, index) => (
                                <TableCell
                                    key={index}
                                    align="start"
                                    sx={{color: theme.typography.secondary, fontWeight: 600}}
                                >
                                    {header}
                                </TableCell>
                            ))}                   
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length > 0 ? (
                            data?.map((vehicle) => (
                                <TableRow key={vehicle.id}>
                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary, fontWeight: 600}}>
                                        {vehicle?.plate_number}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {vehicle.model_manufacturer}
                                    </TableCell>

                                    <TableCell component="th" scope="row" sx={{color: theme.typography.primary}}>
                                        {vehicle.type}
                                    </TableCell>

                                    <TableCell component="th" scope="row">
                                        <CustomChipComponent category="vehicleStatus"
                                            label={(vehicle.status === "Active") ? "Active" 
                                                :
                                                    (vehicle.status === "Deactivated" || vehicle.status === "Deactivate") ? "Deactivated"
                                                :
                                                    (vehicle.status === "Suspended") ? "Suspended"     
                                                :
                                                    (vehicle.status === "Removed") ? "Removed"                            
                                                :
                                                    vehicle.status
                                            }
                                        />
                                    </TableCell>

                                    <TableCell align="start">
                                        <CustomMenuPopperComponent 
                                            data={vehicle} 
                                            setOpen={setOpen}
                                            setSelectedVehicle={setSelectedVehicle}
                                            theme={theme}
                                            organizationId={organizationId}
                                            profile_type={profile_type}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={headers?.length} align="center">
                                    No vehicle data available to display
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {open && 
                <UpdateStatusDialog 
                    open={open} 
                    setOpen={setOpen} 
                    selectedVehicle={selectedVehicle}
                />
            }
        </Paper>
    )
}

export default ListVehicleComponent